import { bunja } from 'bunja';

import { zendesk } from '@flipster/features/src/shared/zendesk/url';
import { alert } from '@flipster/utils/alert';
import { SessionStorageKey, deleteSessionStorage, getSessionStorage } from '@flipster/utils/sessionStorage';

export const rootPopupBunja = bunja(() => {
  bunja.effect(() => {
    const authErrorMessage = getSessionStorage(SessionStorageKey.AuthErrorMessage);
    if (authErrorMessage) {
      if (authErrorMessage === 'api.authBlocked') {
        alert.show({
          title: 'Account suspended',
          message: 'Currently, you are unable to Log in.\nPlease contact customer support for more information.',
          confirmText: 'Contact Support',
          onConfirm() {
            window.location.href = zendesk.getUrl('RequestNew');
          },
          closeText: 'Close',
        });
      } else {
        alert.show({ message: 'Looks like your session expired.\nPlease log in again.' });
      }
      deleteSessionStorage(SessionStorageKey.AuthErrorMessage);
    }
    return () => {};
  });

  return {};
});
